import { makeRequest } from 'utils/requestLogger';

export default (discussion_id) =>
  makeRequest('put', `/api/live_discussions/${discussion_id}/turn_off_queue`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/turnOffQueue.js